// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__ZdrPZ","summary":"CartItem_summary__vZ1AZ","price":"CartItem_price__C7CDu","amount":"CartItem_amount__nAEdK","actions":"CartItem_actions__SrOBQ"};